import React, { useEffect, useState } from "react";
import userAPI from "../../api/UserApi";
import { showError, showSuccess } from "../../utils/toastUtils";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";

import {  Row, Col, Form, Button } from "react-bootstrap";
import useNumericInput from "../../hooks/useNumericInput"; // 🌟 YEH LINE ADD KAR DE BHAI
import { Mail, Phone, User, CheckCircle } from "lucide-react";

function Account() {
  useAlphabeticInput();
  useNumericInput();

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    phone: "",
    firstName: "",
    lastName: "",
    email: "",
  });

  useEffect(() => {
    fetchMyDetails();
  }, []);

  const fetchMyDetails = async () => {
    const res = await userAPI.getDetails();
    if (res.code === 200) {
      const result = res.data;

      setFormData({
        phone: result?.mobile || "",
        firstName: result?.firstName || "",
        lastName: result?.lastName || "",
        email: result?.email || "",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.firstName) {
      newErrors.firstName = "Please Enter First Name";
    }

    if (!formData.phone) {
      newErrors.phone = "Please Enter Phone Number";
    } else if (formData.phone.length < 10) {
      newErrors.phone = "Phone number must be exactly 10 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const res = await userAPI.updateDetails(formData);
      if (res.code === 200) {
        showSuccess(res.message || "Profile specifications updated cleanly");
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="orangeapes-account-dashboard-wrapper mb-5">
        <div className="orangeapes-account-settings-box p-4 p-md-5">
          
          {/* HEADER LAYER */}
          <div className="account-section-header mb-5">
            <h5 className="orangeapes-dashboard-main-title mb-2">Account Details</h5>
            <p className="orangeapes-dashboard-subtitle">
              Maintain your profile registries and personal shipping identification matrices below.
            </p>
          </div>

          <Form onSubmit={handleDetailsSubmit} className="orangeapes-dashboard-form">
            
            {/* ROW 1: INLINE FIRST NAME & LAST NAME */}
            <Row className="g-4 mb-4">
              <Col md={6}>
                <Form.Group className="orangeapes-input-group-row" controlId="firstName">
                  <Form.Label className="orangeapes-form-custom-label">
                    First Name <span className="text-orange-token">*</span>
                  </Form.Label>
                  <div className="orangeapes-field-input-wrapper">
                    <User size={16} className="orangeapes-field-icon" />
                    <Form.Control
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="orangeapes-blank-input only-alphabets"
                    />
                  </div>
                  {errors && errors.firstName && (
                    <span className="orangeapes-error-validation-msg">{errors.firstName}</span>
                  )}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="orangeapes-input-group-row" controlId="lastName">
                  <Form.Label className="orangeapes-form-custom-label">
                    Last Name
                  </Form.Label>
                  <div className="orangeapes-field-input-wrapper">
                    <User size={16} className="orangeapes-field-icon" />
                    <Form.Control
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="orangeapes-blank-input only-alphabets"
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>

            {/* ROW 2: INLINE READONLY EMAIL & PHONE NUMBER */}
            <Row className="g-4 mb-5">
              <Col md={6}>
                <Form.Group className="orangeapes-input-group-row group-field-readonly" controlId="email">
                  <Form.Label className="orangeapes-form-custom-label label-disabled">
                    Email Address <span className="locked-badge-text">(Locked)</span>
                  </Form.Label>
                  <div className="orangeapes-field-input-wrapper wrapper-disabled">
                    <Mail size={16} className="orangeapes-field-icon icon-disabled" />
                    <Form.Control
                      type="email"
                      name="email"
                      readOnly
                      value={formData.email}
                      className="orangeapes-blank-input input-disabled"
                    />
                  </div>
                  <span className="orangeapes-input-micro-note-txt mt-2">
                    <b>Note:</b> Primary registry email cannot be modified.
                  </span>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="orangeapes-input-group-row" controlId="phone">
                  <Form.Label className="orangeapes-form-custom-label">
                    Phone Number <span className="text-orange-token">*</span>
                  </Form.Label>
                  <div className="orangeapes-field-input-wrapper">
                    <Phone size={16} className="orangeapes-field-icon" />
                    <Form.Control
                      type="text"
                      name="phone"
                      placeholder="10-Digit Mobile"
                      value={formData.phone}
                      maxLength={10}
                      onChange={handleChange}
                      className="orangeapes-blank-input only-numeric"
                    />
                  </div>
                  {errors && errors.phone && (
                    <span className="orangeapes-error-validation-msg">{errors.phone}</span>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* SUBMIT BUTTON */}
            <div className="d-flex justify-content-start">
              <Button
                className="orangeapes-dashboard-submit-btn py-3 px-5 d-flex align-items-center gap-2"
                type="submit"
              >
                <span>SAVE CHANGES</span>
                <CheckCircle size={14} />
              </Button>
            </div>

          </Form>
        </div>
      </div>
    </>
  );
}

export default Account;